import React from 'react';
import {
    Button,
    Card,
    Checkbox,
    Col,
    Collapse,
    Empty,
    Form,
    Icon,
    Input,
    Row,
    Select,
    Skeleton,
    Spin,
    Table
} from "antd";
import { createDebounce, sanitizeFieldName } from "../../util/methods";
import { geolocated } from "react-geolocated";
import { Link } from "react-router-dom";
import Qrcode from "./qrcode";
import AccessControl from "../../components/AccessControl";
import Linker from "./Linker";
import AssetSearch from "../../components/AssetSearch";

const { Panel } = Collapse;

/** Wrapper so getFieldDecorator receives a real component (avoids rc-form 'in' operator on undefined) */
const AssetSearchField = ({ value, onChange, assetList = [], searchOnChange, loading }) => {
    const defaultAsset = value
        ? (assetList.find(a => a._id === value) || { _id: value, assetCode: value, altName: '', ownerCode: '' })
        : null;
    return (
        <AssetSearch
            key={value || 'none'}
            styleName="gx-lt-icon-search-bar-lg"
            placeholder="Or search any Asset..."
            defaultAsset={defaultAsset}
            assetData={assetList}
            onChange={searchOnChange}
            onSelect={onChange || (() => { })}
            loading={loading}
        />
    );
};

class Create extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            resourceData: [],
            deviceType: 'pc',
            columns: [],
            selectedAsset: null,
            linkVisible: false,
            tableData: [],
            redirectedPOData: null,
            setSubTypeSelect: false,
        };
    }

    componentDidMount() {
        if (this.props.width >= 1024) {
            this.setState({ deviceType: 'pc' });
        } else if (this.props.width >= 768) {
            this.setState({ deviceType: 'tablet' });
        } else {
            this.setState({ deviceType: 'mobile' });
        }

        const { match, fetchAssetById, assetTypes, equipmentSubTypes } = this.props;
        // console.log(match.params)
        if (match.params && match.params.po) {
            this.props.onSubmit({ pi: match.params.po });
            if (match.params.poCode) {
                this.setState({
                    redirectedPOData: { _id: match.params.po, name: match.params.poCode }
                })
            }
        } else {
            this.setState({
                redirectedPOData: null
            })
            // console.log(assetTypes)
            if (!assetTypes || !assetTypes.length)
                this.props.getAllAssetType();
            if (!equipmentSubTypes || !equipmentSubTypes.length)
                this.props.getEquipmentSubTypeByAssetTypes('All');
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps && nextProps.data/* && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)*/) {
            this.setState({
                tableData: nextProps.data,
            })
        }

        if (nextProps && nextProps.paramAsset && JSON.stringify(nextProps.paramAsset) !== JSON.stringify(this.props.paramAsset)) {
            this.setState({
                tableData: [nextProps.paramAsset],
            })
        }

        if (nextProps && nextProps.width && nextProps.width !== this.props.width) {
            if (this.props.width >= 1024) {
                this.setState({ deviceType: 'pc' });
            } else if (this.props.width >= 768) {
                this.setState({ deviceType: 'tablet' });
            } else {
                this.setState({ deviceType: 'mobile' });
            }
        }
        this.cols();
    }

    // handleAssetTypesChange = (e) => {
    //     this.props.getEquipmentSubTypeByAssetTypes('All');
    // }
    //
    // setSubTypeSelectHandle = (v)=>{
    //     if(v){
    //         this.setState({
    //             setSubTypeSelect : true
    //         })
    //     }
    // }

    fetchSearch = (value, type = 'Asset') => {
        if (value && value.length >= 3) {
            if (type === 'Asset')
                this.props.fetchRelationshipSearchData(value, 'Asset', 'assetCode');
            else if (type === 'Model')
                this.props.fetchRelationshipSearchData(value, 'AssetModel', 'name');
        }
    };

    linkToggleVisible = () => {
        this.setState((prevState) => {
            return { linkVisible: !prevState.linkVisible }
        });
    }

    handleOpenLinkAsset = (assetData) => {
        // console.log(assetData)
        if (assetData) {
            this.setState({
                selectedAsset: assetData,
            }, () => {
                this.setState({
                    linkVisible: true,
                })
            })
        }
    }

    handleSubmit = e => {
        // console.log(`On submit`);
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            // console.log(values)
            this.props.onSubmit(values);
        });
    }

    cols = () => {
        let columns = [
            {
                title: "Code",
                dataIndex: "assetCode",
                key: "assetCode",
                width: '250px',
                render: (_, record) => (
                    <span style={{ verticalAlign: 'center' }}>
                        {record && record.assetCode + '/' + (record.ownerCode || '') + '/' + (record.altName || '')}&nbsp;
                        <Link
                            to={`/asset-tagging/list/${record && record._id}`}><Icon
                                type="search" /></Link>

                    </span>
                )
            },
        ];
        if (this.state.deviceType === 'tablet') {
            columns = columns.concat([
                // {
                //     title: "Alt Name",
                //     dataIndex: "altName",
                //     key: "altName",
                // },
                {
                    title: "QR",
                    dataIndex: "qrNew",
                    key: "qrNew",
                    width: '120px',
                    render: (_, record, index) => {
                        const qrs = (record.scannerData || []).filter(doc => doc.type === 'QR');
                        // console.log(qrs);
                        if (qrs && qrs.length && qrs[0]['id']) {
                            return <Qrcode id={qrs[0]['id']} index={index} />
                        }
                    }
                },
            ])
        } else if (this.state.deviceType === 'pc') {
            columns = columns.concat([
                // {
                //     title: "Alt Name",
                //     dataIndex: "altName",
                //     key: "altName",
                // },
                // {
                //   title: "QR",
                //   dataIndex: "qrNew",
                //   key: "qrNew",
                //   width: '120px',
                //   render: (_, record, index) => {
                //     const qrs = (record.scannerData || []).filter(doc => doc.type === 'QR');
                //     // console.log(qrs)
                //     if (qrs && qrs.length && qrs[0]['id']) {
                //       return <Qrcode id={qrs[0]['id']} index={index}/>
                //     }
                //   }
                // },
                {
                    title: "Location",
                    dataIndex: "location",
                    key: "location",
                    render: (record) => record && record.name,
                },
                {
                    title: "Sub Location",
                    dataIndex: "client",
                    key: "client",
                    render: (record) => record && record.name,
                },
                {
                    title: "Sub Type",
                    dataIndex: "equipmentSubType",
                    key: "equipmentSubType",
                    render: (record) => record && record.name,
                },
                {
                    title: "Type",
                    dataIndex: "equipmentSubType.assetType",
                    key: "equipmentSubType.assetType",
                    render: (record) => record && record.name,
                },
                {
                    title: "Model",
                    dataIndex: "assetModel",
                    key: "assetModel",
                    render: (record) => record && record.name,
                },])
        }

        columns.push({
            title: "Action",
            key: "action",
            width: '10',
            render: (_, record) => {

                const qrs = (record.scannerData || []).filter(doc => doc.type === 'QR');
                // if (qrs && qrs.length) {
                //     return <AccessControl resource={this.props.resource} permissionNeeded={'u'}
                //                           roles={this.props.authUser ? this.props.authUser.roles : []}
                //                           render={(props) => {
                //                               return <Button type={'danger'}
                //                                              onClick={this.handleOpenLinkAsset.bind(this, record)}>Update
                //                                   QR</Button>
                //                           }}/>
                // } else
                return (
                    <AccessControl resource={this.props.resource} permissionNeeded={'c'}
                        roles={this.props.authUser ? this.props.authUser.roles : []}
                        render={(props) => {
                            return <Button type={'primary'}
                                onClick={this.handleOpenLinkAsset.bind(this, record)}>{`Link${(qrs && qrs.length) ? ' More' : ''} QR`}</Button>
                        }} />
                )
            }
        });
        this.setState({ columns: columns })
    };

    handlePOSearch = createDebounce((searchValue) => {
        // console.log('Searching for:', searchValue);
        if (searchValue.length > 3) {
            this.props.poSearch(searchValue);
        }
    }, 400); // Adjust the delay (in milliseconds) as needed


    render() {

        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const {
            loading,
            filters,
            title,
            resource,
            authUser,
        } = this.props;
        const { tableData: data, redirectedPOData } = this.state;

        let assetTable = <Skeleton active />;
        assetTable =
            (data) ? (
                <Table
                    dataSource={this.state.tableData}
                    pagination={{ pageSize: 10 }}
                    columns={this.state.columns}
                    loading={this.props.loading}
                    rowKey={(record) =>
                        record._id
                    }
                />
            ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
        // console.log(redirectedPOData)

        return (
            <div>
                <Spin spinning={this.state.loading || loading}>
                    <Collapse bordered={false} defaultActiveKey={[this.props.match.params.asset ? '0' : '1']}
                        expandIconPosition={'right'}>
                        <Panel header="" key="1">
                            <Form onSubmit={this.handleSubmit} layout="inline">
                                <Row>
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item key={'asset'} label={'Asset'} style={{ width: '100%' }}>
                                            {getFieldDecorator(`asset`, {
                                                rules: [{ required: false, message: `Asset is required!` }],
                                            })(
                                                <AssetSearchField
                                                    assetList={this.props.assetSearchData || this.props.assetData || []}
                                                    searchOnChange={this.props.searchGlobalAssetData}
                                                    loading={this.props.assetSearchLoading}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item key={"location"} label={sanitizeFieldName("location")}
                                            style={{ width: '100%' }}>
                                            {getFieldDecorator("location")(
                                                <Select
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                    allowClear
                                                    // onSelect={this.selectedLocation}
                                                    placeholder="Please select location"
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "")
                                                            .toLowerCase()
                                                            .indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                >
                                                    {authUser && authUser.locations.map(itm => (
                                                        <Select.Option key={itm._id} value={itm._id}>
                                                            {itm.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item
                                            key={"client"}
                                            style={{ width: '100%' }}
                                            label={"Sub Location"}
                                        >
                                            {getFieldDecorator("client")(
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    // onSelect={this.selectedSubLocation}
                                                    placeholder="Please select sub location"
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "")
                                                            .toLowerCase()
                                                            .indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                >
                                                    {authUser && authUser.clients.map(itm => (
                                                        <Select.Option key={itm._id} value={itm._id}>
                                                            {itm.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item key={'assetType'} label={'Select Asset Types'}
                                            style={{ width: '100%' }}>
                                            {getFieldDecorator(`assetType`, {
                                                rules: [{ required: false, message: `Asset types is required!` }],
                                                initialValue: null,
                                            })(<Select
                                                showSearch
                                                allowClear
                                                // mode="multiple"
                                                // onSelect={this.setSubTypeSelectHandle}
                                                // onChange={this.handleAssetTypesChange}
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Please Select Asset Type`}
                                            >
                                                {(this.props.assetTypes || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}
                                            </Select>)
                                            }
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item key={'Asset Sub Type'} label={'Select Asset Sub Type'}
                                            style={{ width: '100%' }}>
                                            {getFieldDecorator(`assetSubType`, {
                                                rules: [{ required: false/*this.state.setSubTypeSelect*/, message: `Asset Sub Type is required!` }],
                                                initialValue: null,
                                            })(<Select
                                                showSearch
                                                allowClear
                                                // mode="multiple"
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Please Select Asset Sub Type`}
                                            >
                                                {(this.props.equipmentSubTypes || []).map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}
                                            </Select>)
                                            }
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={4}>
                                        <Form.Item key={'assetModel'} label={'Asset Model'} style={{ width: '100%' }}>
                                            {getFieldDecorator(`assetModel`, {
                                                // rules: [{required: true, message: `Asset Model is required!`}],
                                                initialValue: null,
                                            })(<Select
                                                showSearch
                                                allowClear
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                onSearch={(val) => this.fetchSearch(val, 'Model')}
                                                // onChange={value => this.handleSelect('assetModel', value)}
                                                placeholder={`Please Enter Asset Model`}
                                            >
                                                {this.props.assetData.map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}
                                            </Select>)
                                            }
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={12} md={12} lg={4} xl={4}>
                                        <Form.Item
                                            key={"pi"}
                                            style={{ width: '100%' }}
                                            label={"Purchase Invoice"}
                                        >
                                            {getFieldDecorator("pi", {
                                                initialValue: redirectedPOData && redirectedPOData._id
                                            })(
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    loading={loading}
                                                    onSearch={this.handlePOSearch}
                                                    // onSelect={this.selectedSubLocation}
                                                    placeholder="Please select PI"
                                                    filterOption={(input, option) =>
                                                        (option.props.children + "")
                                                            .toLowerCase()
                                                            .indexOf((input + "").toLowerCase()) >= 0
                                                    }
                                                >
                                                    {redirectedPOData && (
                                                        <Select.Option key={redirectedPOData._id + '_p'}
                                                            value={redirectedPOData._id}>
                                                            {redirectedPOData.name}
                                                        </Select.Option>

                                                    )}
                                                    {this.props.poSearchData && this.props.poSearchData.map(itm =>
                                                        itm && itm.searchModuleType && itm.searchModuleType === "purchaseorder"
                                                        && itm.searchRecordId && itm.searchRecordName &&
                                                        (
                                                            <Select.Option key={itm.searchRecordId}
                                                                value={itm.searchRecordId}>
                                                                {itm.searchRecordName}
                                                            </Select.Option>
                                                        )
                                                    )}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                        <Form.Item key={"check1"} style={{ width: '100%' }} label={null}>
                                            {getFieldDecorator('unLinkedOnly', {
                                                valuePropName: 'checked',
                                                initialValue: true
                                            })(
                                                <Checkbox>
                                                    Show unlinked assets
                                                </Checkbox>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                        <Form.Item key={"check2"} style={{ width: '100%' }} label={null}>
                                            {getFieldDecorator('linkedOnly', {
                                                valuePropName: 'checked',
                                            })(
                                                <Checkbox>
                                                    Show linked assets
                                                </Checkbox>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                        <Form.Item key={`submit`}>
                                            <Button type="primary" className="gx-mb-0" htmlType="submit"
                                                loading={loading}
                                                /*style={{marginTop: this.props.width >= 750 ? '-80px' : 0}}*/>
                                                Show
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Panel>
                    </Collapse>
                    <Card>
                        {assetTable}
                    </Card>
                </Spin>
                {this.state.linkVisible &&
                    <Linker asset={this.state.selectedAsset} linkType={'QR'} createLink={this.props.createLink}
                        coords={this.props.coords}
                        toggleView={this.linkToggleVisible}
                        isVisible={this.state.linkVisible} match={this.props.match} history={this.props.history}
                        form={this.props.form}
                        qrUsed={this.props.qrUsed}
                        loading={loading}
                        linkStatus={this.props.linkStatus}
                        checkQrAlreadyUsed={this.props.checkQrAlreadyUsed} allTagTypes={this.props.allTagTypes}
                        getAllTagTypes={this.props.getAllTagTypes} />
                }
            </div>
        );
    }
}

const CreateForm = Form.create({
    name: "global_state",
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    }
})(Create);

export default geolocated()(CreateForm);
